// components/AnimatedButton.jsx
import React, { useState } from "react";
import { motion } from "framer-motion";

export default function AnimatedButton({
  children,
  onClick,
  disabled = false,
  primary = false,
  className = "",
}) {
  const [isHovered, setIsHovered] = useState(false);

  const buttonVariants = {
    hover: {
      scale: 1.01,
      y: -2,
      transition: { duration: 0.3 },
    },
    tap: { scale: 0.98 },
  };

  return (
    <motion.button
      whileHover="hover"
      whileTap="tap"
      variants={buttonVariants}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`relative  rounded-xl font-bold  transition-all duration-500 overflow-hidden ${
        primary
          ? disabled
            ? "bg-gray-400 cursor-default text-white"
            : "bg-secondary text-white hover:border-primary border  shadow-2xl shadow-secondary/25"
          : disabled
          ? "bg-gray-400 cursor-default text-white border-gray-400 border-2"
          : "border-2 text-white hover:bg-secondary_hover  backdrop-blur-sm shadow-2xl hover:shadow-white/25"
      } ${className}`}
    >
      {/* Animated background for primary button */}
      {primary && !disabled && (
        <motion.div
          className="absolute inset-0 bg-primary_hover "
          initial={{ x: "-100%" }}
          animate={{ x: isHovered ? "0%" : "-100%" }}
          transition={{ duration: 0.3 }}
        />
      )}

      {/* Button content */}
      <span className="relative z-10 flex items-center justify-center gap-2 sm:gap-3">
        {children}
        {primary && !disabled && (
          <motion.svg
            className="w-4 h-4 sm:w-9 sm:h-7"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            animate={{ x: isHovered ? 5 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 7l5 5m0 0l-5 5m5-5H6"
            />
          </motion.svg>
        )}
      </span>

      {/* Shine effect for primary button */}
      {primary && !disabled && (
        <motion.div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12"
          animate={{ x: ["-200%", "200%"] }}
          transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
        />
      )}
    </motion.button>
  );
}
